module.exports = __webpack_public_path__ + "static/lottery-button-disable.5b5f842c.png";